import { useState, useEffect } from "react";
import { Cpu, Monitor, Building2, Scale, BookOpen, Star, Layers } from "lucide-react";
import axios from "axios";
import { usePrefetchedData } from "../common/DataPrefetch";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const GalaxyNav = ({ activeGalaxy, setActiveGalaxy }) => {
  const prefetched = usePrefetchedData();
  const [pulse, setPulse] = useState(null);
  useEffect(() => {
    if (prefetched.pulse) { setPulse(prefetched.pulse); return; }
    const t = setTimeout(() => {
      if (!prefetched.pulse) axios.get(`${API}/pulse`).then(r => setPulse(r.data)).catch(() => {});
    }, 2500);
    return () => clearTimeout(t);
  }, [prefetched.pulse]);

  const GALAXIES = [
    { id: "consciousness", label: "Consciousness", icon: Layers, color: "#a78bfa", description: "The Universe View" },
    { id: "apps", label: "AI Apps", icon: Monitor, color: "#34d399", description: pulse?.total_apps ? `${pulse.total_apps.toLocaleString()} applications` : "applications", ready: true },
    { id: "hardware", label: "Physical AI", icon: Cpu, color: "#60a5fa", description: pulse?.total_devices ? `${pulse.total_devices.toLocaleString()} devices` : "devices", ready: true },
    { id: "research", label: "Research", icon: BookOpen, color: "#06b6d4", description: "Papers & CII", ready: true },
    { id: "companies", label: "Companies", icon: Building2, color: "#f59e0b", description: pulse?.total_companies ? `${pulse.total_companies.toLocaleString()} companies` : "companies", ready: true },
    { id: "policy", label: "Policy", icon: Scale, color: "#06b6d4", description: pulse?.total_policies ? `${pulse.total_policies.toLocaleString()} frameworks` : "frameworks", ready: true },
    { id: "impact", label: "Impact", icon: Star, color: "#f97316", description: "Coming Phase 6", ready: false },
  ];

  return (
    <div className="w-full border-b border-border/50 bg-card/80 backdrop-blur-md" data-testid="galaxy-nav">
      <div className="flex items-center gap-1 px-3 py-1.5 overflow-x-auto" style={{ scrollbarWidth: "none" }}>
        <span className="text-[10px] font-bold text-violet-400/60 uppercase tracking-[0.15em] mr-2 flex-shrink-0 hidden md:inline">ACI</span>
        {GALAXIES.map((g) => {
          const isActive = activeGalaxy === g.id;
          const isReady = g.ready !== false || g.id === "consciousness";
          return (
            <button
              key={g.id}
              onClick={() => isReady && setActiveGalaxy(g.id)}
              disabled={!isReady}
              data-testid={`galaxy-${g.id}`}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all flex-shrink-0 ${
                isActive
                  ? "bg-white/[0.08] text-white"
                  : isReady
                  ? "text-slate-400 hover:text-slate-300 hover:bg-white/[0.04]"
                  : "text-slate-700 cursor-not-allowed opacity-50"
              }`}
              style={isActive ? { borderBottom: `2px solid ${g.color}` } : {}}
            >
              <g.icon className="w-3.5 h-3.5" style={isActive ? { color: g.color } : {}} />
              <span className="hidden sm:inline">{g.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GalaxyNav;
